import StandardProductAvailabilityIndicator from "entities/shared/standard-product/availability-indicator";
import Radio, { RadioVariant } from "shared/ui/radio";
import Text from "shared/ui/typography/Text";
import { concatClassnames } from "shared/utils/concatClassnames";

interface Props {
  isAvailable: boolean;
  isSelected: boolean;
  headingText: string;
  text: string | React.ReactElement;
  onChange: () => void;
  id: string;
}

const StandardProductReceiveMethod = ({
  isAvailable,
  isSelected,
  onChange,
  headingText,
  id,
  text,
}: Props) => {
  return (
    <Radio
      labelClassName="!gg-items-start"
      className="gg-mt-1.5 gg-mr-5"
      variant={RadioVariant.CIRCLE}
      id={id}
      onChange={onChange}
      checked={isSelected}
    >
      <Text className={concatClassnames("gg-mb-1 gg-font-bold")}>
        {headingText}
      </Text>
      <Text className="gg-text-sm gg-flex gg-items-center gg-gap-x-1">
        {/* <StandardProductAvailabilityIndicator isAvailable={isAvailable} /> */}

        {text}
      </Text>
    </Radio>
  );
};
export default StandardProductReceiveMethod;
